import {NodeType} from 'common/src/modules/nodes/nodes.types';

const cardTypeToName: Record<NodeType, string> = {
  [NodeType.WEIGHTED]: 'Weighted',
  [NodeType.GENERAL_OPTIMIZATION]: 'Optimization',
  [NodeType.CONDITION]: 'Condition',
  [NodeType.CREATIVE]: 'Creative',
  [NodeType.CONTENT_FEED]: 'Content',
  [NodeType.SCHEDULE]: 'Schedule',
  [NodeType.SEQUENCE]: 'Sequence',
  [NodeType.DISTRIBUTION]: 'Distribution',
  [NodeType.PRODUCTS]: 'Products',
  [NodeType.STORE]: 'Location',
  [NodeType.COMPOUND_CONDITION]: 'Compound Condition',
  [NodeType.NATIVE_CREATIVE]: 'Native Creative',
  [NodeType.SOCIAL_FACEBOOK_AD_CREATIVE]: 'Social Creative',
  [NodeType.SOCIAL_TIKTOK_AD_CREATIVE]: 'Social Creative',
  [NodeType.SOCIAL_YOUTUBE_AD_CREATIVE]: 'Social Creative',
  [NodeType.SOCIAL_SNAPCHAT_AD_CREATIVE]: 'Social Creative',
  [NodeType.SOCIAL_YOUTUBE_DV360_AD_CREATIVE]: 'Social Creative',
  [NodeType.FACEBOOK_CAROUSEL_CREATIVE]: 'Facebook Carousel Creative',
  [NodeType.CONCEPT_CREATIVE]: 'Concept Creative',
  [NodeType.FACEBOOK_DPA_CREATIVE]: 'Facebook DPA Creative',
  [NodeType.FACEBOOK_DPA_CAROUSEL_CREATIVE]: 'Facebook DPA Carousel Creative',
  [NodeType.VIDEO_CAMPAIGN]: 'Video Campaign',
  [NodeType.CAMPAIGN]: 'Campaign',
  [NodeType.SOCIAL_LINKEDIN_AD_CREATIVE]: 'Social LinkedIn Creative',
};

export {cardTypeToName};
